var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAffiliate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3617 0C0.609655 0 0 0.607072 0 1.35593V5.42373C0 6.17259 0.609655 6.77966 1.3617 6.77966H2.72321C2.7233 7.56496 3.16915 8.57599 3.98049 9.37392C4.82643 10.2059 6.10406 10.8472 7.8296 10.8472C9.1256 10.8472 10.0788 11.2842 10.6991 11.8102C11.3539 12.3655 11.5743 12.9544 11.5743 13.2201H13.2764C13.2764 12.2994 12.6968 11.2781 11.8027 10.5198C10.874 9.73227 9.52934 9.15232 7.8296 9.15232C6.55939 9.15232 5.70936 8.69198 5.17658 8.16801C4.60945 7.61026 4.42546 7.01144 4.42534 6.77966H5.44681C6.19886 6.77966 6.80851 6.17259 6.80851 5.42373V1.35593C6.80851 0.607072 6.19886 0 5.44681 0H1.3617ZM10.5532 13.2203C9.80114 13.2203 9.19149 13.8274 9.19149 14.5763V18.6441C9.19149 19.3929 9.80114 20 10.5532 20H14.6383C15.3903 20 16 19.3929 16 18.6441V14.5763C16 13.8274 15.3903 13.2203 14.6383 13.2203H10.5532Z",
    fill: "#6C6C75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliate);
export default __webpack_public_path__ + "static/media/affiliate.a1daad7d35d407937f09c9b00ded7161.svg";
export { ForwardRef as ReactComponent };